module.exports = __webpack_public_path__ + "media/endgame.ed45f7bc.mp3";